import React, { useState } from 'react'
import { Button, FormGroup } from '@material-ui/core'
import { DropzoneDialog } from 'material-ui-dropzone'

export const ImportButton = ({ handleSave, label, acceptedFiles }) => {
  const [open, setOpen] = useState(false)
  const handleClick = () => setOpen(true)

  const localHandleSave = files => {
    setOpen(false)
    handleSave(files)
  }

  return (
    <FormGroup>
      <Button variant="contained" color="primary" onClick={handleClick} data-test="choose-file">
        {label}
      </Button>
      <DropzoneDialog
        showAlerts={false}
        open={open}
        onSave={localHandleSave}
        dropzoneClass="drop-zone"
        showPreviews={true}
        maxFileSize={5000000}
        acceptedFiles={acceptedFiles}
        onClose={() => setOpen(false)}
        filesLimit={1}
        submitButtonText="Importer"
        cancelButtonText="Annuler"
      />
    </FormGroup>
  )
}
